<template>
  <div>
    <div class="container-fluid">
      <h1 data-v-step="receivedReferralsHeader">
        Incoming Referrals / Requests
      </h1>
      <div class="row filter">
        <div class="col-12">
          <div>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-3">
                <label class="col-12 col-md-1 font-weight-bold pt-2"
                  >Vendors</label
                >
                <alert
                  v-if="orderVendorsLoading"
                  class="py-8-px shadow-card"
                ></alert>
                <select
                  v-else
                  v-model="filters.selectedVendor"
                  @change="
                    (filters.filterIsDirty = true),
                      (filters.selectedService = -1),
                      (filters.selectedLocation = -1)
                  "
                  class="form-control shadow-card"
                >
                  <option :value="-1">Select a Vendor</option>
                  <option
                    v-for="vendor in vendorsForDropdown"
                    :value="vendor.value"
                    :key="vendor.value"
                    :style="vendor.isArchived ? 'color: #e63757;' : ''"
                  >
                    {{ vendor.label }}
                    <span v-if="vendor.isArchived">(Archived)</span>
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-md-0 mt-sm-3">
                <label class="col-12 col-md-1 font-weight-bold pt-2"
                  >Services</label
                >
                <alert
                  v-if="orderVendorsLoading"
                  class="py-8-px shadow-card"
                ></alert>
                <select
                  v-else
                  v-model="filters.selectedService"
                  @change="filters.filterIsDirty = true"
                  class="form-control shadow-card"
                >
                  <option :value="-1">Select a Service</option>
                  <option
                    v-for="service in filteredServices"
                    :value="service.value"
                    :key="service.value"
                  >
                    {{ service.label }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-md-0 mt-sm-3">
                <label class="col-12 col-md-1 font-weight-bold pt-2"
                  >Locations</label
                >
                <alert
                  v-if="orderVendorsLoading"
                  class="py-8-px shadow-card"
                ></alert>
                <select
                  v-else
                  v-model="filters.selectedLocation"
                  @change="filters.filterIsDirty = true"
                  class="form-control shadow-card"
                >
                  <option :value="-1">Select a Location</option>
                  <option
                    v-for="location in filteredLocations"
                    :value="location.value"
                    :key="location.value"
                    :style="location.isArchived ? 'color: #e63757;' : ''"
                  >
                    {{ location.label }}
                    <span v-if="location.isArchived">(Archived)</span>
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-md-0 mt-sm-3">
                <label class="col-12 col-md-1 font-weight-bold pt-2"
                  >Status</label
                >
                <select
                  v-model="filters.selectedStatus"
                  @change="filters.filterIsDirty = true"
                  class="form-control shadow-card"
                >
                  <option :value="-1">Select a Status</option>
                  <option
                    v-for="status in statuses"
                    :value="status.value"
                    :key="status.value"
                  >
                    {{ status.label }}
                  </option>
                </select>
              </div>
            </div>
            <br />
            <br />
            <div class="custom-control custom-switch mb-3">
              <input
                type="checkbox"
                class="custom-control-input"
                id="all-received-referrals"
                @change="filters.filterIsDirty = true"
                v-model="filters.filterByDate"
              />
              <label
                class="custom-control-label cursor-pointer"
                for="all-received-referrals"
              >
                Filter by Creation Date
              </label>
            </div>
            <div
              class="row border-bottom align-items-center"
              v-if="filters.filterByDate"
            >
              <label class="col-12 col-md-1 font-weight-bold py-2 mb-2"
                >Date</label
              >
              <div class="mt-2 pt-1 col-12 col-md-6">
                <v-date-picker
                  v-model="filters.range"
                  @input="filters.filterIsDirty = true"
                  mode="date"
                  :masks="masks"
                  is-range
                >
                  <template v-slot="{ inputValue, inputEvents, isDragging }">
                    <div
                      class="d-flex justify-content-start align-items-center form-group"
                    >
                      <input
                        class="px-2 py-1 form-control shadow-card"
                        :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                        :value="inputValue.start"
                        v-on="inputEvents.start"
                      />
                      <div class="mx-4">-</div>
                      <input
                        class="px-2 py-1 form-control shadow-card"
                        :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                        :value="inputValue.end"
                        v-on="inputEvents.end"
                      />
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </div>
            <br />
            <div class="my-4 d-flex justify-content-between flex-wrap">
              <div class="d-flex flex-wrap align-items-center">
                <button
                  class="mr-3 btn btn-primary text-uppercase view-report position-relative"
                  :disabled="receivedReferralsLoading"
                  @click="viewReport(1), (filters.filterIsDirty = false)"
                >
                  View Report
                  <div
                    class="action-indicator btn btn-danger spinner-grow"
                    v-if="filters.filterIsDirty"
                  ></div>
                </button>
              </div>
              <div class="d-flex flex-wrap">
                <div
                  class="d-flex align-items-center"
                  v-if="getFilteredOrderVendors.length"
                >
                  <button
                    @click="showExportReceivedReferralsModal"
                    class="btn btn-primary btn-success mt-sm-0 mt-3 mr-2"
                  >
                    Export Referrals
                  </button>
                </div>
                <div
                  class="d-flex align-items-center"
                  v-if="
                    !receivedReferralsLoading &&
                    receivedReferralsData.length > 0
                  "
                >
                  <button
                    @click="deleteRequests()"
                    class="btn btn-primary btn-danger mt-sm-0 mt-3 mr-2"
                  >
                    <i class="fas fa-trash"></i> Delete
                    {{ selectedOrders.length ? "Selected" : "All" }}
                  </button>

                  <button
                    @click="readRequests()"
                    class="btn btn-primary btn-info mt-sm-0 mt-3 mr-2"
                  >
                    <i class="fas fa-envelope-open"></i> Read
                    {{ selectedOrders.length ? "Selected" : "All" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <alert
        v-if="!receivedReferralsLoading && receivedReferralsData.length == 0"
        class="white-bg shadow-card"
        >No Referrals</alert
      >
      <loading
        v-if="receivedReferralsLoading && receivedReferralsData.length == 0"
        class="white-bg shadow-card"
      />
      <TablePagination
        @onPageChange="onPageChangeHelper"
        :count="total"
        :rowsPerPage="limit"
        :currentPage="currentPage"
        showTopPagination
        showFirstButton
        showLastButton
        v-if="receivedReferralsData.length > 0"
      >
        <loading
          v-if="receivedReferralsLoading"
          class="white-bg my-5 mx-3 alert alert-light"
        />
        <div class="card received-card mb-3" v-if="!receivedReferralsLoading">
          <div class="table-responsive rounded">
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th v-if="displayedColumns.name">Name</th>
                  <th v-if="displayedColumns['service type']">Service Type</th>
                  <th v-if="displayedColumns.vendor" class="vendor-cell">
                    Vendor
                  </th>
                  <th v-if="displayedColumns.status">Status</th>
                  <th
                    v-if="displayedColumns.created"
                    class="text-center created-cell"
                  >
                    Created
                  </th>
                  <th
                    v-if="displayedColumns['due date']"
                    class="text-center due-cell"
                  >
                    Due Date
                  </th>
                  <th v-if="displayedColumns['mark as']">Mark As</th>
                  <th v-if="displayedColumns['details']">Details</th>
                  <th class="text-center">Actions</th>
                  <th>
                    <input
                      class="cursor-pointer"
                      type="checkbox"
                      v-model="selectAll"
                      @change="selectDeselectAll"
                    />
                  </th>
                  <th>
                    <button
                      class="btn btn-default context-menu-btn"
                      type="button"
                      id="dropdownMenu1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <ul
                      class="dropdown-menu table-checkbox-menu allow-focus"
                      aria-labelledby="dropdownMenu1"
                    >
                      <li
                        v-for="(value, name) in displayedColumns"
                        :key="name"
                        :class="value ? 'active' : ''"
                      >
                        <label>
                          <input
                            type="checkbox"
                            v-model="displayedColumns[name]"
                          />
                          {{ name }}
                        </label>
                      </li>
                    </ul>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="order in receivedReferralsData"
                  :key="order.id"
                  class="mobile-tablet-shadow-card rounded"
                  :class="!order.user ? 'disabled-no-user' : ''"
                >
                  <td v-if="displayedColumns.name" class="name-td">
                    <b class="mobile-tablet-only mr-2">Name:</b>
                    <p>
                      {{ (order.user || {}).last || "" }},
                      {{ (order.user || {}).first || "" }}
                      <br />
                      <span class="small text-muted">{{
                        (order.user || {}).email || ""
                      }}</span>
                    </p>

                    <span
                      class="badge badge-pill badge-danger mr-2"
                      v-if="order.makeContact"
                    >
                      <icon type="check" />Make Contact ASAP
                    </span>
                    <a
                      v-if="order.makeContact"
                      :href="`tel:${(order.user || {}).phone || ''}`"
                      class="small"
                      style="display: inline-block"
                      >{{ (order.user || {}).phone || "" }}</a
                    >
                  </td>
                  <td v-if="displayedColumns['service type']">
                    <b class="mobile-tablet-only mr-2">Service Type:</b>
                    <badge
                      v-if="order.sub_service"
                      class="badge-light service-type"
                      >{{ order.service }} / {{ order.sub_service }}</badge
                    >
                    <badge v-else class="badge-light">{{
                      order.service
                    }}</badge>
                    <div v-if="order.attachments.length > 0" class="py-2">
                      <h3 class="m-0">
                        Attachment(s)
                        <span v-if="order.consent_provided">
                          -
                          <badge color="success"
                            ><i class="fas fa-check"></i> Consent
                            Provided</badge
                          >
                        </span>
                      </h3>

                      <p
                        class="text-muted small p-0 m-0"
                        v-for="attachment in order.attachments"
                        :key="attachment.id"
                      >
                        <span v-if="!attachment.isExpired">
                          <a :href="attachment.url" target="_blank">
                            <icon type="file" />
                            {{ attachment.name }}
                          </a>
                        </span>
                        <span v-else>
                          <badge color="danger">Expired</badge>
                          {{ attachment.name }}
                        </span>
                      </p>
                    </div>
                  </td>
                  <td v-if="displayedColumns.vendor">
                    <b class="mobile-tablet-only mr-2">Vendor:</b>
                    {{ (order.vendor || {}).name }}
                  </td>
                  <td v-if="displayedColumns.status">
                    <b class="mobile-tablet-only mr-2">Status:</b>
                    <badge
                      style="white-space: normal; line-height: 1.5"
                      :class="
                        labelColor(
                          order.status,
                          parseInt(order.deleted_form_client)
                        )
                      "
                      >{{
                        parseInt(order.deleted_form_client)
                          ? "DELETED BY SENDER"
                          : order.status
                      }}</badge
                    >
                  </td>
                  <td v-if="displayedColumns.created" class="text-center">
                    <b class="mobile-tablet-only mr-2" v-if="order.created_at"
                      >Created:</b
                    >
                    {{ order.created_at | fullDate }}
                  </td>
                  <td v-if="displayedColumns['due date']" class="text-center">
                    <b class="mobile-tablet-only mr-2">Due Date:</b>
                    <p v-if="order.due_at">
                      {{ prettyDate(order.due_at, "YYYY-MM-DD") }}
                    </p>
                    <button
                      v-if="!order.deleted_form_client"
                      type="button"
                      @click="setDueDate(order, $event)"
                      class="btn btn-light btn-sm"
                    >
                      <i class="fas fa-calendar fa-fw"></i> Set Due Date</button
                    >&nbsp;
                  </td>
                  <td v-if="displayedColumns['mark as']">
                    <b
                      class="mobile-tablet-only mr-2"
                      v-if="!order.deleted_form_client"
                      >Mark As:</b
                    >
                    <div
                      class="btn-group"
                      role="group"
                      v-if="!order.deleted_form_client"
                    >
                      <button
                        id="btnGroupDrop1"
                        type="button"
                        class="btn btn-sm btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Status
                      </button>
                      <div
                        class="dropdown-menu py-0 referral-status-menu"
                        aria-labelledby="btnGroupDrop1"
                        x-placement="bottom-start"
                        style="
                          position: absolute;
                          will-change: transform;
                          top: 0px;
                          left: 0px;
                          max-height: 240px;
                          overflow: auto;
                          transform: translate3d(0px, 41px, 0px);
                        "
                      >
                        <a
                          @click="changeStatus(order, 'RECIEVED')"
                          :class="
                            order.status == `RECIEVED` ? `active-item` : ``
                          "
                          class="dropdown-item badge badge-secondary badge-soft-secondary"
                          href="#"
                          >Received</a
                        >
                        <a
                          @click="changeStatus(order, 'FULFILLED')"
                          :class="
                            order.status == `FULFILLED` ? `active-item` : ``
                          "
                          class="dropdown-item badge badge-warning badge-soft-warning"
                          href="#"
                          >Fulfilled</a
                        >
                        <a
                          @click="changeStatus(order, 'COORDINATED')"
                          :class="
                            order.status == `COORDINATED` ? `active-item` : ``
                          "
                          class="dropdown-item badge badge-info"
                          href="#"
                          >Coordinated</a
                        >
                        <a
                          @click="changeStatus(order, 'SHIPPED')"
                          :class="
                            order.status == `SHIPPED` ? `active-item` : ``
                          "
                          class="dropdown-item badge badge-info badge-soft-info"
                          href="#"
                          >Shipped</a
                        >
                        <a
                          @click="changeStatus(order, 'COMPLETED')"
                          :class="
                            order.status == `COMPLETED` ? `active-item` : ``
                          "
                          class="dropdown-item badge badge-success"
                          href="#"
                          >Completed</a
                        >

                        <a
                          @click="
                            changeStatus(
                              order,
                              'Your appointment has been scheduled'
                            )
                          "
                          :class="
                            order.status ==
                            `Your appointment has been scheduled`
                              ? `active-item`
                              : ``
                          "
                          class="dropdown-item badge badge-primary"
                          href="#"
                          >Your appointment has been scheduled</a
                        >
                        <a
                          @click="
                            changeStatus(
                              order,
                              'Our team will be contacting you soon to discuss request'
                            )
                          "
                          :class="
                            order.status ==
                            `Our team will be contacting you soon to discuss request`
                              ? `active-item`
                              : ``
                          "
                          class="dropdown-item badge badge-warning"
                          href="#"
                          >Our team will be contacting you soon to discuss
                          request</a
                        >
                        <a
                          @click="
                            changeStatus(
                              order,
                              'Vendor does not offer requested service(s) and/or product(s)'
                            )
                          "
                          :class="
                            order.status ==
                            `Vendor does not offer requested service(s) and/or product(s)`
                              ? `active-item`
                              : ``
                          "
                          class="dropdown-item badge badge-danger"
                          href="#"
                          >Vendor does not offer requested service(s) and/or
                          product(s)</a
                        >
                        <a
                          @click="
                            changeStatus(
                              order,
                              'Vendor is requesting you re-send information'
                            )
                          "
                          :class="
                            order.status ==
                            `Vendor is requesting you re-send information`
                              ? `active-item`
                              : ``
                          "
                          class="dropdown-item badge badge-dark"
                          href="#"
                          >Vendor is requesting you re-send information</a
                        >
                      </div>
                    </div>
                  </td>
                  <td v-if="displayedColumns.details">
                    <b class="mobile-tablet-only mr-2" v-if="order.details"
                      >Details:</b
                    >
                    <button
                      class="btn btn-sm order-details-btn"
                      v-if="order.details && order.details.trim().length > 20"
                      @click="viewOrderDetails(order.details)"
                    >
                      View
                    </button>
                    <span
                      v-if="order.details && order.details.trim().length <= 20"
                      >{{ order.details }}</span
                    >
                  </td>
                  <td class="text-center delete-td">
                    <button
                      @click="deleteRequest(order.id)"
                      class="btn text-danger"
                    >
                      <i class="fas fa-trash" title="delete"></i>
                      <span class="mobile-tablet-only pl-2">Delete</span>
                    </button>
                    <button
                      title="Report User"
                      @click="reportUser(order)"
                      class="btn text-warning"
                    >
                      <i class="fas fa-lg fa-bug" title="Report User"></i>
                      <span class="mobile-tablet-only pl-2">Report User</span>
                    </button>
                    <button
                      v-if="!order.read_by"
                      title="Mark as read"
                      @click="readRequest(order.id)"
                      class="btn text-info"
                    >
                      <i
                        class="fas fa-lg fa-envelope-open"
                        title="Mark as read"
                      ></i>
                      <span class="mobile-tablet-only pl-2">Mark As Read</span>
                    </button>
                  </td>
                  <td>
                    <input
                      class="cursor-pointer"
                      type="checkbox"
                      :id="`check_order_${order.id}_id`"
                      v-model="order.selected"
                      @change="checkSelectedOrders"
                    />
                    <label
                      :for="`check_order_${order.id}_id`"
                      class="mobile-tablet-only ml-2 cursor-pointer"
                      >Select to delete
                      {{ order.read_by ? "" : ", mark as read" }}</label
                    >
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </TablePagination>
    </div>
    <ShowContentModal title="Order Details" :content="selectedDetails" />
    <ExportReceivedReferralsModal
      :vendors="getFilteredOrderVendors"
      :statuses="statuses"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import flatpickr from "flatpickr";
import Swal from "sweetalert2";
import jQuery from "jquery";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import Auth from "../../auth";
import * as helpers from "@/utils/helpers";
import ExportReceivedReferralsModal from "./ExportReceivedReferralsModal.vue";
import ShowContentModal from "./ShowContentModal.vue";
import TablePagination from "../../components/TablePagination.vue";
import _ from "lodash";

dayjs.extend(utc);

export default {
  name: "Received",
  components: {
    ExportReceivedReferralsModal,
    TablePagination,
    ShowContentModal,
  },
  data() {
    return {
      selectAll: false,
      selectedOrders: [],
      displayedColumns: {
        name: true,
        "service type": true,
        vendor: true,
        status: true,
        created: true,
        "due date": this.isMobile(),
        "mark as": true,
        details: true,
      },
      statuses: [
        { label: "Received", value: "RECIEVED" },
        { label: "Fulfilled", value: "FULFILLED" },
        { label: "Pending", value: "PENDING" },
        { label: "Coordinated", value: "COORDINATED" },
        { label: "Shipped", value: "SHIPPED" },
        { label: "Completed", value: "COMPLETED" },
        {
          label: "Your appointment has been scheduled",
          value: "Your appointment has been scheduled",
        },
        {
          label: "Our team will be contacting you soon to discuss request",
          value: "Our team will be contacting you soon to discuss request",
        },
        {
          label: "Vendor does not offer requested service(s) and/or product(s)",
          value: "Vendor does not offer requested service(s) and/or product(s)",
        },
        {
          label: "Vendor is requesting you re-send information",
          value: "Vendor is requesting you re-send information",
        },
      ],
      masks: {
        input: "YYYY-MM-DD",
      },
      limit: 50,
      filters: {
        filterIsDirty: false,
        filterByDate: false,
        selectedService: -1,
        selectedVendor: -1,
        selectedStatus: -1,
        selectedLocation: -1,
        range: {
          start: new Date(),
          end: new Date(),
        },
      },
      submittedFilters: {
        filterByDate: false,
        selectedService: -1,
        selectedVendor: -1,
        selectedStatus: -1,
        selectedLocation: -1,
        range: {
          start: new Date(),
          end: new Date(),
        },
      },
      selectedDetails: "",
    };
  },
  computed: {
    ...mapState(["orders"]),
    ...mapState({
      receivedReferralsData: (state) => state.orders.received.pagination.data,
      total: (state) => state.orders.received.pagination.total,
      currentPage: (state) => state.orders.received.pagination.current_page,
      receivedReferralsLoading: (state) => state.orders.isLoading.received,
      orderVendorsLoading: (state) => state.orders.orderVendors.loading,
      orderVendors: (state) => state.orders.orderVendors.data,
    }),
    loggedInUser: function () {
      return Auth.user.get();
    },
    filteredServices: function () {
      const vm = this;
      let services = [];
      if (this.filters.selectedVendor != -1) {
        const vendor = this.orderVendors.find(
          (userVendor) => userVendor.id == vm.filters.selectedVendor
        );
        if (vendor) {
          services = vendor.services;
        }
      } else {
        services = this.orderVendors
          .reduce(
            (mergedServices, vendor) => mergedServices.concat(vendor.services),
            []
          )
          .sort((a, b) => (a.name > b.name ? 1 : -1));
      }
      const uniqueArray = _.uniqBy(services, "id");
      return uniqueArray.map((service) => {
        return {
          value: service.id,
          label: service.name,
        };
      });
    },
    filteredLocations: function () {
      const vm = this;
      let locations = [];
      if (this.filters.selectedVendor != -1) {
        const vendor = this.orderVendors.find(
          (userVendor) => userVendor.id == vm.filters.selectedVendor
        );
        if (vendor) {
          locations = vendor.locations;
        }
      } else {
        locations = this.orderVendors.reduce(
          (mergedLocations, vendor) => mergedLocations.concat(vendor.locations),
          []
        );
      }
      const uniqueArray = _.uniqBy(locations, "id");
      let locationsForDropdown = uniqueArray
        .map((location) => {
          return {
            value: location.id,
            label: helpers.formatLocation(location),
            isArchived: location.is_archived ? true : false,
          };
        })
        .sort((a, b) => {
          return a.isArchived && !b.isArchived ? 1 : -1;
        });
      locationsForDropdown.push({
        value: "NOT_AVAILABLE",
        label: "Others (orders that do not specify a location, if any)",
      });
      return locationsForDropdown;
    },
    vendorsForDropdown: function () {
      return this.orderVendors
        .map((vendor) => {
          return {
            value: vendor.id,
            label: vendor.name,
            isArchived: vendor.is_archived ? true : false,
          };
        })
        .sort((a, b) => {
          return a.isArchived && !b.isArchived ? 1 : -1;
        });
    },
    getFilteredOrderVendors: function () {
      const loggedInUserId = this.loggedInUser.id;
      return this.orderVendors.filter((vendor) => {
        return vendor.primary_contacts.includes(loggedInUserId);
      });
    },
  },
  mounted() {
    this.getVendors({ id: this.loggedInUser.id });
    this.getNewReceivedReferralsCount();
    this.getReceivedReferralsHelper(
      this.$route.query.pageNumber || 1,
      this.submittedFilters
    );
    jQuery(".table-checkbox-menu").on(
      "change",
      "input[type='checkbox']",
      function () {
        jQuery(this).closest("li").toggleClass("active", this.checked);
      }
    );
    jQuery(document).on("click", ".allow-focus", function (e) {
      e.stopPropagation();
    });
  },
  methods: {
    ...mapActions({
      getReceivedReferrals: "orders/allReceived",
      getVendors: "orders/getOrderVendors",
      getNewReceivedReferralsCount: "orders/newReceivedCount",
    }),
    isMobile: function () {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    changeStatus: function (order, status) {
      this.$store.dispatch("orders/updateStatus", {
        order: order,
        id: order.id,
        status: status,
      });
    },
    setDueDate: function (order, e) {
      let root = this;
      const fp = flatpickr(e.target, {
        dateFormat: "Y-m-d",
        onChange: function (selected, str, instance) {
          root.$store
            .dispatch("orders/setDueDate", {
              order: order,
              due: str,
            })
            .then((res) => {
              if (res) {
                root.getReceivedReferralsHelper(
                  root.currentPage,
                  root.submittedFilters
                );
              }
            });
        },
      });
      fp.open();
    },
    labelColor: function (status, deleted) {
      if (deleted) {
        return "badge-danger";
      } else if (status == "RECEIVED") {
        return "badge-secondary badge-soft-secondary";
      } else if (status == "FULFILLED") {
        return "badge-warning badge-soft-warning";
      } else if (status == "SHIPPED") {
        return "badge-info badge-soft-info";
      } else if (status == "COMPLETED") {
        return "badge-success";
      } else if (status == "Your appointment has been scheduled") {
        return "text-uppercase badge-primary badge-primary-force";
      } else if (
        status == "Our team will be contacting you soon to discuss request"
      ) {
        return "text-uppercase badge-warning";
      } else if (
        status == "Vendor does not offer requested service(s) and/or product(s)"
      ) {
        return "text-uppercase badge-danger";
      } else if (status == "Vendor is requesting you re-send information") {
        return "text-uppercase badge-dark";
      } else if (status !== "PENDING") {
        return "text-uppercase badge-info";
      }
    },
    deleteRequests: function () {
      const vm = this;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, delete ${
            vm.selectedOrders.length ? "selected" : "all"
          }`,
          cancelButtonText: "No, cancel",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            let actionName = "orders/deleteAllIncomingReferrals";
            if (vm.selectedOrders.length) {
              actionName = "orders/deleteSelectedIncomingReferrals";
            }
            vm.$store
              .dispatch(actionName, vm.selectedOrders)
              .then((deleted) => {
                if (deleted) {
                  this.getNewReceivedReferralsCount();
                  this.getReceivedReferralsHelper(
                    this.currentPage,
                    this.submittedFilters
                  );
                  swalWithBootstrapButtons.fire(
                    "Deleted!",
                    "Your incoming referrals have been deleted.",
                    "success"
                  );
                } else {
                  swalWithBootstrapButtons.fire(
                    "Error!",
                    "Something went wrong. Please refresh the page and try again",
                    "error"
                  );
                }
              });
          }
        });
    },
    readRequests: function () {
      const vm = this;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, mark ${
            vm.selectedOrders.length ? "selected" : "all"
          } as read`,
          cancelButtonText: "No, cancel",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            let actionName = "orders/readAllIncomingReferrals";
            if (vm.selectedOrders.length) {
              actionName = "orders/readSelectedIncomingReferrals";
            }
            vm.$store.dispatch(actionName, vm.selectedOrders).then((done) => {
              if (done) {
                this.getNewReceivedReferralsCount();
                this.getReceivedReferralsHelper(
                  this.currentPage,
                  this.submittedFilters
                );
                swalWithBootstrapButtons.fire(
                  "Marked as read!",
                  "Your incoming referrals have been marked as read.",
                  "success"
                );
              } else {
                swalWithBootstrapButtons.fire(
                  "Error!",
                  "Something went wrong. Please refresh the page and try again",
                  "error"
                );
              }
            });
          }
        });
    },
    readRequest: function (id) {
      const vm = this;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, mark as read",
          cancelButtonText: "No, cancel",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            vm.$store
              .dispatch("orders/readIncomingReferral", id)
              .then((done) => {
                if (done) {
                  this.getNewReceivedReferralsCount();
                  this.getReceivedReferralsHelper(
                    this.currentPage,
                    this.submittedFilters
                  );
                  swalWithBootstrapButtons.fire(
                    "Marked as read!",
                    "Incoming referral has been marked as read.",
                    "success"
                  );
                } else {
                  swalWithBootstrapButtons.fire(
                    "Error!",
                    "Something went wrong. Please refresh the page and try again",
                    "error"
                  );
                }
              });
          }
        });
    },
    deleteRequest: function (id) {
      const vm = this;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete",
          cancelButtonText: "No, cancel",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            vm.$store
              .dispatch("orders/deleteIncomingReferral", id)
              .then((deleted) => {
                if (deleted) {
                  this.getNewReceivedReferralsCount();
                  this.getReceivedReferralsHelper(
                    this.currentPage,
                    this.submittedFilters
                  );
                  swalWithBootstrapButtons.fire(
                    "Deleted!",
                    "Incoming referral has been deleted.",
                    "success"
                  );
                } else {
                  swalWithBootstrapButtons.fire(
                    "Error!",
                    "Something went wrong. Please refresh the page and try again",
                    "error"
                  );
                }
              });
          }
        });
    },
    reportUser: function (order) {
      const vm = this;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-danger mr-4",
          cancelButton: "btn btn-secondary",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          html: `<h4 class="text-dark"">Briefly explain the reason for reporting ${
            (order.user || {}).last || ""
          }, ${(order.user || {}).first || ""}?</h4>
        <small class="text-danger font-weight-bold">The reported user will be deactivated until an investigation has been conducted by C3<small>`,
          input: "textarea",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: "Report",
          showLoaderOnConfirm: true,
          preConfirm: (reason) => {
            return vm.$store
              .dispatch("users/createUserReport", {
                user_id: order.user.id,
                reason,
              })
              .then((response) => {
                return response.data.data;
              })
              .catch((error) => {
                Swal.showValidationMessage(
                  `Request failed: ${
                    ((error.data || {}).error || {}).message ||
                    "Something went wrong. Please refresh the page and try again"
                  }`
                );
              });
          },
          allowOutsideClick: () => !Swal.isLoading(),
        })
        .then((result) => {
          if (result.value) {
            Swal.fire({
              title: "Report User",
              text: "User Reported Successfully",
              type: "success",
            });
          }
        });
    },
    viewReport: function (page) {
      if (!this.filters.filterIsDirty || this.receivedReferralsLoading) {
        return;
      }
      this.submittedFilters = JSON.parse(JSON.stringify(this.filters));
      this.getReceivedReferralsHelper(page, this.filters);
    },
    getReceivedReferralsHelper: function (page, filters) {
      const payload = {
        page,
        limit: this.limit,
      };
      if (filters.filterByDate) {
        const modifiedDateRange = helpers.adjustTimePeriod(
          filters.range.start,
          filters.range.end
        );
        payload["start"] = modifiedDateRange.start;
        payload["end"] = modifiedDateRange.end;
      } else {
        payload["all"] = true;
      }
      if (filters.selectedService != -1) {
        payload["service_id"] = filters.selectedService;
      }
      if (filters.selectedVendor != -1) {
        payload["vendor_id"] = filters.selectedVendor;
      }
      if (filters.selectedLocation != -1) {
        payload["location_id"] = filters.selectedLocation;
      }
      if (filters.selectedStatus != -1) {
        payload["status"] = filters.selectedStatus;
      }
      this.getReceivedReferrals(payload).then((res) => {
        if (res) {
          if (page != this.$route.query.pageNumber) {
            this.$router.replace({
              path: this.$route.path,
              query: {
                pageNumber: page,
              },
            });
          }
        }
      });
    },
    prettyDate: function (date, format = null) {
      return helpers.prettyDate(date, format);
    },
    hideExportReceivedReferralsModal: function () {
      this.$store.dispatch("hideModal", "export-received-referrals-modal");
    },
    showExportReceivedReferralsModal: function () {
      this.$store.dispatch("showModal", "export-received-referrals-modal");
    },
    onPageChangeHelper: function (page) {
      this.getReceivedReferralsHelper(page, this.submittedFilters);
    },
    selectDeselectAll: function () {
      this.receivedReferralsData.forEach(
        (order) => (order.selected = this.selectAll)
      );
      this.checkSelectedOrders();
    },
    checkSelectedOrders: function () {
      const orders = [];
      this.receivedReferralsData.forEach((order) => {
        if (order.selected) {
          orders.push(order.id);
        }
      });
      if (orders.length == this.receivedReferralsData.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
      this.selectedOrders = orders;
    },
    viewOrderDetails: function (details) {
      this.selectedDetails = details;
      this.$store.dispatch("showModal", "show-content-modal");
    },
  },
};
</script>

<style scoped lang="scss">
.referral-status-menu {
  padding-left: 12px;
  padding-right: 12px;
  .dropdown-item {
    &.badge {
      font-size: 15px;
      margin-top: 6px;
      margin-bottom: 6px;
      line-height: 1.5;
    }
    &.active-item {
      box-shadow: 0 0 6px 2px #333333;
    }
  }
}

.badge-primary-force {
  color: #fff;
  background-color: #2c7be5;
}
.small-shadow-card {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
}
.py-8-px {
  padding-top: 8px;
  padding-bottom: 8px;
}
.action-indicator {
  width: 12px;
  height: 12px;
  padding: 0;
  position: absolute;
  top: 0px;
  right: 1px;
}
.view-report,
.order-details-btn {
  background-color: #0e43ad;
  color: #fff;
}
.due-cell {
  min-width: 152px;
}
.created-cell {
  min-width: 152px;
}
.vendor-cell {
  min-width: 200px;
}
.context-menu-btn {
  color: #95aac9;
}

tr {
  &.disabled-no-user {
    pointer-events: none;
    opacity: 0.5;
  }
}

.text-muted {
  color: #6286ba !important;
}

@media (max-width: 1024px) {
  .requests.section {
    .received-card {
      box-shadow: none !important;
      border: 0 !important;
      background-color: transparent !important;
    }
    table {
      display: flex;
    }
    thead {
      display: none;
    }
    tbody {
      width: 100%;
    }
    tr {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;
      padding: 8px;
      td {
        padding: 0 4px;
        text-align: left !important;
        border: 0 !important;
        b {
          display: inline-block;
          padding: 4px 0;
        }
        .text-muted {
          color: #152e4d !important;
        }
        .service-type {
          max-width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .rating-value {
          display: inline-block;
        }

        &.name-td {
          p {
            display: inline-block;
            padding-right: 8px;
            margin-bottom: 0;
            br {
              display: none;
            }
          }
        }
        &.delete-td {
          text-align: center !important;
          margin-bottom: 8px;
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #ccc !important;
          .btn {
            padding: 4px 8px;
            margin-bottom: 8px;

            &:hover,
            &:focus {
              opacity: 0.9;
            }

            &.text-danger {
              color: #fff !important;
              background-color: #e63757;
              border-color: #e63757;
            }

            &.text-warning {
              color: #333333 !important;
              background-color: #f6c343;
              border-color: #f6c343;
              margin-left: 8px;
              margin-right: 8px;
            }

            &.text-info {
              color: #fff !important;
              background-color: #39afd1;
              border-color: #39afd1;
            }
          }
        }
      }
    }
  }
}
</style>
